export function manuallyAddScript(email: string): void {
  if (!email) {
    console.error('Email is required to add the script.');
    return;
  }

  // Check if the script already exists to prevent duplicates
  const existingScript = document.querySelector('script[data-manual-script="hj-identifier"]');
  if (existingScript) {
    console.warn('The script is already added.');
    return;
  }

  // The Angular original injected an inline <script> with the email interpolated
  // into its source; calling hj() directly is equivalent and avoids the injection
  // vector. The marker element preserves the original run-once guard.
  const marker = document.createElement('script');
  marker.type = 'text/javascript';
  marker.dataset['manualScript'] = 'hj-identifier';
  document.body.appendChild(marker);

  (window as any).hj && (window as any).hj('identify', email, {});
  console.log('Script successfully added to the end of the body.');
}
